var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useQuery } from '@apollo/client';
import { t } from '@lingui/core/macro';
import { Menu } from '@pocketlaw/tetris';
import { useField } from 'formik';
import { useDebounce } from 'use-debounce';
import { AddMetadataReferenceFileSelectionDocument } from './AddMetadataReferenceFileSelection.gql';
import { RemoveSelection } from './RemoveSelection';
import { SubmitSelection } from './SubmitSelection';
export function AddMetadataReferenceFileSelection(props) {
    const { isMultiSelect, label } = props;
    const [query, setQuery] = useDebounce('', 250);
    const [field, , helpers] = useField('value');
    const { data, loading } = useQuery(AddMetadataReferenceFileSelectionDocument, {
        variables: {
            query,
        },
    });
    const currentValues = field.value;
    const isSelected = (value) => {
        const valueArr = Array.isArray(currentValues) ? currentValues : [currentValues];
        return valueArr.includes(value);
    };
    const getNewValues = (newValue) => {
        const selected = isSelected(newValue);
        if (!isMultiSelect) {
            return newValue;
        }
        if (selected) {
            return currentValues.filter((selectedValue) => selectedValue !== newValue);
        }
        return [...currentValues, newValue];
    };
    const handleSelect = (value) => __awaiter(this, void 0, void 0, function* () {
        const newValues = getNewValues(value);
        helpers.setValue(newValues);
    });
    return (<Menu.ItemNested target={label}>
      <Menu.HeaderSearch onChange={setQuery} loading={loading} placeholder={t({
            message: 'Search files...',
            comment: 'Metadata: Add metadata reference file selection - Search placeholder',
        })}/>
      {data === null || data === void 0 ? void 0 : data.search.results.map((result) => (<Menu.Item key={result.id} selected={isSelected(result.entityId)} onClick={() => handleSelect(result.entityId)}>
          {result.name}
        </Menu.Item>))}
      <Menu.Footer sticky withoutPadding>
        {isMultiSelect && <SubmitSelection />}
        <RemoveSelection />
      </Menu.Footer>
    </Menu.ItemNested>);
}
